import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'presentation/components/icons/LoadingPlaceholder';
import messageEnums from 'enums/messages';
import overrideStyle from 'lib/overrideStyle';

export function DataRequestStatusBanner(props) {
  return (
    <Wrapper>
      <StatusBanner backgroundColor={props.statusBannerAssets.backgroundColor}>
        <StatusBannerText color={props.statusBannerAssets.color}>{props.statusBannerAssets.text}</StatusBannerText>
        {props.statusBannerAssets.shouldShowWaitingDots ? <LoadingPlaceholder /> : null}
      </StatusBanner>
    </Wrapper>
  );
}

DataRequestStatusBanner.propTypes = {
  status: PropTypes.string,
  statusBannerAssets: PropTypes.object.isRequired,
};

const StatusBannerText = overrideStyle('div')`
  color: ${p => p.color};
  font-family: ${p => p.theme.fontLibrary.primary};
  font-size: 12px;
  font-weight: 500;
  margin: 10px 0px;
  text-align: center;
`;

const StatusBanner = overrideStyle('div')`
  display: flex;
  justify-content: center;
  flex-direction: column
  background-color: ${p => p.backgroundColor};
  margin-top: auto;
  width: 100%;
`;

const Wrapper = overrideStyle('div')`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

function handleStatusAssets(status) {
  switch (status) {
    case messageEnums.SECURE_DATA_STATUSES.COMPLETE:
      return {
        color: '#ffffff',
        backgroundColor: '#009b00',
        text: 'Completed',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_STATUSES.ERROR:
      return {
        backgroundColor: 'red',
        color: '#1D1C1C',
        text: 'Error',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_STATUSES.WAITING:
      return {
        backgroundColor: '#F0F0F0',
        color: '#1D1C1C',
        text: 'Waiting',
        shouldShowWaitingDots: true,
      };
    case messageEnums.SECURE_DATA_STATUSES.SENT:
      return {
        backgroundColor: '#F0F0F0',
        color: '#1D1C1C',
        text: 'Sent',
        shouldShowWaitingDots: false,
      };
    case messageEnums.SECURE_DATA_STATUSES.TIMEOUT:
      return {
        backgroundColor: '#F0F0F0',
        color: '#1D1C1C',
        text: 'Timeout',
        shouldShowWaitingDots: false,
      };
  }
}

export const mapStateToProps = () => {
  let status = messageEnums.SECURE_DATA_STATUSES.COMPLETE;

  return {
    statusBannerAssets: handleStatusAssets(status),
  };
};

export default connect(
  mapStateToProps,
  null
)(DataRequestStatusBanner);
